var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCake(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 6.0625V4.5625",
    stroke: "#F687B3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00002 4.5625C10.8875 3.5625 8.00002 1.0625 8.00002 1.0625C8.00002 1.0625 5.00002 3.5625 8.00002 4.5625Z",
    stroke: "#F687B3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.125 8.4375C10.125 9.00109 9.90112 9.54159 9.5026 9.9401C9.10409 10.3386 8.56359 10.5625 8 10.5625C7.43641 10.5625 6.89591 10.3386 6.4974 9.9401C6.09888 9.54159 5.875 9.00109 5.875 8.4375",
    stroke: "#F687B3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.87501 8.43751C5.87513 8.9936 5.65726 9.52758 5.26816 9.92486C4.87906 10.3221 4.34973 10.5511 3.79376 10.5625C2.60001 10.5875 1.62501 9.58751 1.62501 8.39376V7.56251C1.62419 7.3653 1.66242 7.16987 1.73751 6.98751C1.8126 6.80515 1.92306 6.63946 2.06251 6.50001C2.20196 6.36056 2.36765 6.2501 2.55001 6.17501C2.73237 6.09992 2.9278 6.06169 3.12501 6.06251H12.875C13.0722 6.06169 13.2677 6.09992 13.45 6.17501C13.6324 6.2501 13.7981 6.36056 13.9375 6.50001C14.077 6.63946 14.1874 6.80515 14.2625 6.98751C14.3376 7.16987 14.3758 7.3653 14.375 7.56251V8.39376C14.375 9.58751 13.4 10.5875 12.2063 10.5625C11.6503 10.5511 11.121 10.3221 10.7319 9.92486C10.3428 9.52758 10.1249 8.9936 10.125 8.43751",
    stroke: "#F687B3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 10.1445V13.5633C13.5 13.6959 13.4473 13.8231 13.3536 13.9168C13.2598 14.0106 13.1326 14.0633 13 14.0633H3C2.86739 14.0633 2.74021 14.0106 2.64645 13.9168C2.55268 13.8231 2.5 13.6959 2.5 13.5633V10.1445",
    stroke: "#F687B3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCake);
export default __webpack_public_path__ + "static/media/Cake.5e1ad07bc2ebd0bdb01619c87c030270.svg";
export { ForwardRef as ReactComponent };